export const LegacyIdMapping = {
  FLEX_STANDARD: '3KGS7aLlVLHLiWGYBdeID',
  FLEX_STARTER: '7LQyRNBrypfcJ39OvJMKpk',
  FLEX_ADVANCED: '1zrKGPByFyY8uasgawGsIo',
  STATION_DUO_QUICK_SERVICE_DINING: '6xzHzmQkjwUIOvoW8P3HVl',
  STATION_DUO_RETAIL_AND_SERVICES: '5Y8t6xwxK60S7TaOWzrs3y',
  STATION_SOLO_FULL_SERVICE_DINING: '5Q5s9NlGQnMI0vvkRwceFp',
  STATION_SOLO_RETAIL_AND_SERVICES: '7obkiU3hLwnwDco0EDjhM6',
  GO_STANDARD: '6kVsQ9U9qayZlBRibhBeRC',
  GO_STARTER: '5LxcPigDBWQ3dprpWzbKOG',
  MINI_RETAIL_AND_SERVICES_STANDARD: '17XNJOTaqTOS1pZ9jydp3n',
  MINI_RETAIL_AND_SERVICES_ADVANCED: '5nhUaWQ4FOCgKgySwy4Ygg',
  MINI_RETAIL_AND_SERVICES_STARTER: '4Y1q21FqJHrFdWLJpTJlCd',
  MINI_QUICK_SERVICE_DINING: '2juSOYussTj316KcabBdMW',
  MINI_FULL_SERVICE_DINING: '5xMbcfoJ4kigCmoKiqCawE',
 };
